import _ from 'lodash'

const helpers = {
  // from "1,2,3" to [1,2,3]
  // from "1,3,5-7" to [1,3,5,6,7]
  // from "1,2,
  //     2,3,45"

  explodeSerials (serials) {
    // split per virgole e new line
    // const chunks = serials.split(/,|\n| /)

    return _.chain(serials)
      .split(/[,\n ]/)
      .invokeMap('trim')           // trim
      .filter(c => c)               // tolgo i vuoti
      .reduce((ret, chunk) => {     // e creo un array esplodendo i range
        // not a range, just add it
        if (!chunk.includes('-'))
          return ret.concat(Number(chunk))

        // range, get min and max
        let [min, max] = chunk.split('-')
        min = Number(min)
        max = Number(max)
        if (min>max || max-min>10000) return ret
        return ret.concat(_.range(min, max+1))
        }, [])
      .sortBy()
      .sortedUniq()
      .value()
  },

  nSerials (serials) {
    const ret = helpers.explodeSerials(serials)
    return ret.length
  },

  isSerialsAvailable (availableSerials, checkedSerials) {
    const tmpAvailable = helpers.explodeSerials(availableSerials)
    const tmpChecked = helpers.explodeSerials(checkedSerials)
    return _.difference(tmpChecked, tmpAvailable).length === 0
  },

  serialsAvailability (availableSerials, checkedSerials) {
    const tmpAvailable = helpers.explodeSerials(availableSerials)
    const tmpChecked = helpers.explodeSerials(checkedSerials)
    return _.intersection(tmpChecked, tmpAvailable)
  },

  getFirstSerials (availableSerials, n) {
    const ret = helpers.explodeSerials(availableSerials).slice(0, n)
    return this.compatSerials(ret)
  },

  subtractSerials (availableSerials, toRemoveSerials) {
    const tmpAvailable = helpers.explodeSerials(availableSerials)
    const tmpRemove = helpers.explodeSerials(toRemoveSerials)
    return _.difference(tmpAvailable, tmpRemove)
  },

  mergeSerials (a, b) {
    const tmpA = helpers.explodeSerials(a)
    const tmpB = helpers.explodeSerials(b)
    return _.union(tmpA, tmpB).sort( (a,b) => a-b)
  },

  compatSerials (serials) {
    // [1,2,3,4,5,8,9,10,234,453]
    // "1-5,8-10,234,453"
    let lastN = null
    let rangeMin
    let isRange = false
    let ret = []
    _.forEach(serials, serial => {
      if (lastN === null) {
        lastN = serial
        return
      }
      if (serial === lastN+1) {
        if (!isRange) {
          rangeMin = lastN
          isRange = true
        }
      } else {
        if (isRange) {
          if (rangeMin === lastN-1) {
            ret.push(rangeMin)
            ret.push(lastN)
          } else {
            ret.push(`${rangeMin}-${lastN}`)
          }
          isRange = false
        } else {
          ret.push(lastN)
        }
      }
      lastN = serial
    })
    if (isRange) {
      if (rangeMin === lastN-1) {
        ret.push(rangeMin)
        ret.push(lastN)
      } else {
        ret.push(`${rangeMin}-${lastN}`)
      }
    } else {
      ret.push(lastN)
    }
    return ret.join(',')
  }

}

export default helpers